import React from 'react';
import { Card } from '@/components/ui/card';

interface Resource {
  title: string;
  link: string;
  icon: React.ReactNode;
}

interface LectureSidebarProps {
  resources: Resource[];
  extraContent?: React.ReactNode;
}

/**
 * A standardized sidebar component for lecture pages
 */
const LectureSidebar: React.FC<LectureSidebarProps> = ({ 
  resources,
  extraContent
}) => {
  return (
    <>
      <Card className="p-4 mb-6">
        <h3 className="font-medium text-lg mb-4">Resources</h3>
        <ul className="space-y-2">
          {resources.map((resource, index) => (
            <li key={index}>
              <a 
                href={resource.link} 
                className="flex items-center text-blue-600 hover:text-blue-800"
              >
                <span className="mr-2">{resource.icon}</span>
                {resource.title}
              </a>
            </li>
          ))}
        </ul>
      </Card>
      
      {extraContent}
    </>
  );
};

export default LectureSidebar;